import { createSelector } from '@reduxjs/toolkit';
import { storeSelector } from '../../Global/StoreSelector';

const name = createSelector(storeSelector, (state) => state.createMoonList.name);
const isPublic = createSelector(storeSelector, (state) => state.createMoonList.isPublic);
const search = createSelector(storeSelector, (state) => state.createMoonList.search);
const searchLanguage = createSelector(storeSelector, (state) => state.createMoonList.searchLanguage);
const searchResults = createSelector(storeSelector, (state) => state.createMoonList.searchResults);
const moons = createSelector(storeSelector, (state) => state.createMoonList.moons);
const canCreate = createSelector(
  storeSelector,
  (state) => state.createMoonList.name.length > 0 && state.createMoonList.moons.length > 0
);
const hasCreatedSuccessfully = createSelector(
  storeSelector,
  (state) => state.createMoonList.state.current === 'success'
);

export default {
  name,
  isPublic,
  search,
  searchLanguage,
  searchResults,
  moons,
  canCreate,
  hasCreatedSuccessfully
};
